const sampleCsvData = [
  {
    nationalId: '1107454009',
    freelancerNumber: 'FL-013988291',
    type: 'FULL',
  },
  {
    nationalId: '1107454009',
    freelancerNumber: 'FL-595215341',
    type: 'BASIC',
  },
];

const freelancerSampleCsvFile = {
  fileName: 'freelancer-verification-bulk-upload.csv',
  sampleCsvData,
};

export { freelancerSampleCsvFile };

